// @ts-nocheck
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const isValidYear = (y) => Number.isInteger(y) && y >= 2000 && y <= 2100;

const normalizeYear = (year) => {
  const y = parseInt(String(year), 10);
  if (!isValidYear(y)) return null;
  return y;
};

/**
 * Année seule dans l'URL V2 (?year=) pour les pages all-time / graphs calendaires.
 */
export function useV2Year() {
  const location = useLocation();
  const navigate = useNavigate();
  const defaultYear = useMemo(() => new Date().getFullYear(), []);

  const parseYearFromSearch = () => {
    const params = new URLSearchParams(location.search);
    const year = params.get("year");
    if (!year) return null;
    return normalizeYear(year);
  };

  const [year, setYearState] = useState(() => parseYearFromSearch() ?? defaultYear);

  const syncUrlYear = (nextYear, { replace = true } = {}) => {
    const params = new URLSearchParams(location.search);
    params.delete("month");
    params.set("year", String(nextYear));
    const nextSearch = `?${params.toString()}`;
    if (nextSearch !== location.search) {
      navigate({ pathname: location.pathname, search: nextSearch }, { replace });
    }
  };

  useEffect(() => {
    const fromUrl = parseYearFromSearch();
    if (fromUrl != null && fromUrl !== year) {
      setYearState(fromUrl);
      return;
    }
    if (fromUrl == null) {
      syncUrlYear(year);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has("month")) {
      syncUrlYear(year);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const setYear = (nextYear, options) => {
    const normalized = normalizeYear(nextYear);
    if (normalized == null) return;
    setYearState(normalized);
    syncUrlYear(normalized, options);
  };

  return { year, setYear };
}

export function buildV2YearSearch(locationSearch, year = new Date().getFullYear()) {
  const params = new URLSearchParams(locationSearch || "");
  params.delete("month");
  params.set("year", String(year));
  return `?${params.toString()}`;
}
